//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/BaseCreator.js";
import "../no/ObjectSelector.js";
import "../no/ObjectSelector.js";
let d=[[[0,"EnableHybridDesign",1,0],[0,"ExportFrom",1,0],[1,"ExportSelectionBlock",0,"ObjectSelector",0],[0,"FileSaveFlag",1,0],[0,"IncludeBlankedObj",1,0],[0,"IncludeCSYS",1,0],[0,"IncludeIndWireFrame",1,0],[0,"IncludeRefGeom",1,0],[0,"InputFile",1,0],[0,"SettingsFile",1,0]],[[["filename"],"SaveSettings",{},1,0]],[]];
SPLM.Catiav5Creator = class extends SPLM.BaseCreator{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Catiav5Creator";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Catiav5Creator.ExportFromOption = Object.freeze({
    "DisplayPart" : "DisplayPart", "ExistingPart" : "ExistingPart"});

export default SPLM;